import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';
import { getS3ImageUrl } from '@/utility/content';

const welcomeBg = getS3ImageUrl('/home/partner-welcome-bg.png');
const welcomeBgTopMob = getS3ImageUrl('/home/partner-welcome-bg-top-mob.png');
const welcomeBgBottomMob = getS3ImageUrl('/home/partner-welcome-bg-bottom-mob.png');

export const Container = styled.section`
  .welcome,
  &.welcome {
    position: relative;
    display: flex;
    padding: 64px 0 40px;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
      height: 100%;
    }

    &:before {
      left: 0;
      background-color: ${p => p.theme.palette.home.left};
      background-image: url(${welcomeBg});
      background-size: cover;
      background-repeat: no-repeat;
      width: 75%;
    }

    &:after {
      right: 0;
      background-color: ${p => p.theme.palette.home.right};
      width: 25%;
    }

    ${breakpoints.down('xs')} {
      background-color: ${p => p.theme.palette.home.left};
      text-align: center;
      padding: 50px 0 0;

      :before,
      &:after {
        height: auto;
      }

      &:before {
        height: 230px;
        width: 309px;
        left: auto;
        right: 0;
        background-color: transparent;
        background-image: url(${welcomeBgTopMob});
        background-repeat: no-repeat;
      }

      &:after {
        width: 185px;
        height: 282px;
        top: auto;
        right: auto;
        left: 0;
        bottom: 0;
        background-color: transparent;
        background-image: url(${welcomeBgBottomMob});
        background-repeat: no-repeat;
      }
    }

    &__content {
      position: relative;
      z-index: 1;
      padding-bottom: 16px;

      .MuiGrid-item {
        position: relative;
      }

      ${breakpoints.down('xs')} {
        overflow: hidden;
      }
    }

    &__left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding-top: 0;
      padding-bottom: 0;
      color: ${p => p.theme.palette.home.leftText};

      ${breakpoints.down('sm')} {
        padding-bottom: 0;
      }

      ${breakpoints.down('xs')} {
        align-items: center;
        min-height: auto;
        padding-top: 0;
        padding-bottom: 24px;
      }
    }

    &__title {
      font-weight: 600;
    }

    &__subtitle {
      line-height: 2.4rem;
    }

    &__title,
    &__subtitle {
      ${breakpoints.down('sm')} {
        white-space: normal;
      }
    }
  }
`;

export default Container;
